import { GlobalEvents } from '@highlight/ipc'
import { SELF_VOICE_SCORE_EVENT } from '@shared/self-voice'

/** The embedding's similarity to the user's fingerprint, which only main holds, or null when main won't score it. */
export async function scoreAgainstFingerprint(embedding: Array<number>): Promise<number | null> {
  try {
    return await GlobalEvents.invoke<number | null>(SELF_VOICE_SCORE_EVENT, embedding)
  } catch (error) {
    console.error('[SelfVoice] Could not score an embedding', error)
    return null
  }
}
